import React, { useState, useEffect } from "react";
import { message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import Type from "@actionTypes";
import { checkPerm } from "@utils/utils";
import {
  ORIGINALEVIDENCE,
  LITIGATIONLEGALDOC,
  EXECUTIONLEGALDOC,
  LITIPRSVLEGALDOC,
  MEDIATIONLEGALDOC,
} from "@utils/constant";
import DetailCard from "./detailCard";

//
const ElectronicDossierDetail = (props) => {
  const { path, systemNum, cardPath, permChildren, showPDF, getDoc, showCode, signature } = props;
  const [keyMap, setKeyMap] = useState({});
  const [modal, setModal] = useState({ modalKey: "", uploadModal: false });
  const [resId, setResId] = useState("");
  const [pdfView, setPdfView] = useState("");
  const [resParam, setResParam] = useState({ status: 1 });
  const dispatch = useDispatch();

  const { sourceTree } = useSelector((state) => state.app);

  const { reviewResult = [] } = sourceTree;

  const caseDetail = useSelector((state) => state.caseDetail) || {};
  const detail = caseDetail?.[systemNum] || {};

  useEffect(() => {
    const isFindKey = Object?.keys(caseDetail)?.find(key => key === systemNum);
    if (!isFindKey) {
      getDoc();
    }
    return () => {};
  }, [systemNum]);

  const onSelectChange = (id, selectedRow) => {
    const urlList = selectedRow.map((item) => item.materialUrl);
    setKeyMap({
      ...keyMap,
      [systemNum]: {
        ...keyMap?.[systemNum],
        [id]: urlList,
      },
    });
  };

  const downloadFile = (id) => {
    if (keyMap?.[systemNum]?.[id].length !== 0) {
      dispatch({
        type: Type.DOWNLOAD_ELE,
        path,
        param: {
          pathList: keyMap[systemNum][id],
        },
      });
    } else {
      message.info("请选择需要下载的文件");
    }
  };

  const openModal = (id) => {
    setModal({
      modalKey: id,
      uploadModal: true,
    });
  };

  const deleteFile = (url) => {
    dispatch({
      type: Type.GET_DELETEFILE,
      path,
      url,
      cb: getDoc,
    });
  };

  const printFile = (id) => {
    if (keyMap?.[systemNum]?.[id].length !== 0) {
      dispatch({
        type: Type.GET_PDFCONVERSION,
        path,
        systemNum,
        params: { urls: keyMap[systemNum][id] },
        cb: (url) => {
          const wind = window.open(
            url,
            "newwindow",
            "height=0, width=0, top=100, left=100, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no"
          );
          wind.print();
        },
      });
    } else {
      message.info("请选择需要打印的文件");
    }
  };

  const printSingleFile = (file) => {
    const { systemNum, path } = props;
    dispatch({
      type: Type.GET_PDFCONVERSION,
      path,
      systemNum,
      params: { urls: [file] },
      cb: (url) => {
        const wind = window.open(
          url,
          "newwindow",
          "height=0, width=0, top=100, left=100, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=n o, status=no"
        );
        wind.print();
      },
    });
  };

  // const signature = (id, sign) => {
  //   const { systemNum } = props;
  //   let resID = id;
  //   if (id) {
  //     setResId(id);
  //     resID = id;
  //   } else {
  //     resID = resId;
  //   }
  //   showCode(true)
  //   // dispatch({
  //   //     type: Type.GET_SIGN,
  //   //     resID,
  //   //     systemNum,
  //   //     sign,
  //   //     cb: ()=> setShowCode(true)
  //   // });
  // };

  const showPdf = (url, record, pdfType) => {
    dispatch({
      type: Type.GET_PDFCONVERSION,
      path,
      systemNum,
      params: { urls: [url] },
      cb: (pdfUrl) => {
        setPdfView(pdfUrl);
        showPDF({ isShowPDF: true, pdfType, record });
      },
    });
  };

  const closePdf = () => {
    setPdfView("");
    setResParam({ status: 1 });
    getDoc();
  };

  const handldeResParam = (value, name) => {
    setResParam({
      ...resParam,
      [name]: value,
    });
  };


  return props.isShowPDF ? (
    <div className="caseDetails" style={{ height: "100%" }}>
      <iframe
        src={pdfView}
        style={{ border: "none", width: "100%", height: "100%" }}
        title="文书审核"
      ></iframe>
    </div>
  ) : (
    <div>
      {/* todo 权限*/}
      {/*{checkPerm(permChildren?.[ORIGINALEVIDENCE]?.perm, 4) && (*/}
      {/*  <DetailCard*/}
      {/*    title="原始证据材料"*/}
      {/*    id="originalEvidence"*/}
      {/*    data={detail?.[`${cardPath}/${ORIGINALEVIDENCE}`] || []}*/}
      {/*    onSelectChange={onSelectChange}*/}
      {/*    downloadFile={downloadFile}*/}
      {/*    openModal={openModal}*/}
      {/*    deleteFile={deleteFile}*/}
      {/*    printFile={printFile}*/}
      {/*    printSingleFile={printSingleFile}*/}
      {/*    signature={signature}*/}
      {/*    showPdf={showPdf}*/}
      {/*    canDelete={checkPerm(permChildren?.[ORIGINALEVIDENCE]?.perm, 2)}*/}
      {/*    reviewResult={reviewResult}*/}
      {/*    // cz={path.split("/")[1] === "workbench"}*/}
      {/*  />*/}
      {/*)}*/}
      {/*{checkPerm(permChildren?.[LITIGATIONLEGALDOC]?.perm, 4) && (*/}
      {/*  <DetailCard*/}
      {/*    title="诉讼相关法律文书"*/}
      {/*    id="litigationLegalDoc"*/}
      {/*    data={detail?.[`${cardPath}/${LITIGATIONLEGALDOC}`] || []}*/}
      {/*    onSelectChange={onSelectChange}*/}
      {/*    downloadFile={downloadFile}*/}
      {/*    openModal={openModal}*/}
      {/*    deleteFile={deleteFile}*/}
      {/*    printFile={printFile}*/}
      {/*    printSingleFile={printSingleFile}*/}
      {/*    signature={signature}*/}
      {/*    showPdf={showPdf}*/}
      {/*    canDelete={checkPerm(permChildren?.[LITIGATIONLEGALDOC]?.perm, 2)}*/}
      {/*    reviewResult={reviewResult}*/}
      {/*    // cz={path.split("/")[1] === "workbench"}*/}
      {/*  />*/}
      {/*)}*/}
      {/*{checkPerm(permChildren?.[EXECUTIONLEGALDOC]?.perm, 4) && (*/}
      {/*  <DetailCard*/}
      {/*    title="执行相关法律文书"*/}
      {/*    id="executionLegalDoc"*/}
      {/*    data={detail?.[`${cardPath}/${EXECUTIONLEGALDOC}`] || []}*/}
      {/*    onSelectChange={onSelectChange}*/}
      {/*    downloadFile={downloadFile}*/}
      {/*    openModal={openModal}*/}
      {/*    deleteFile={deleteFile}*/}
      {/*    printFile={printFile}*/}
      {/*    printSingleFile={printSingleFile}*/}
      {/*    signature={signature}*/}
      {/*    showPdf={showPdf}*/}
      {/*    canDelete={checkPerm(permChildren?.[EXECUTIONLEGALDOC]?.perm, 2)}*/}
      {/*    reviewResult={reviewResult}*/}
      {/*    // cz={path.split("/")[1] === "workbench"}*/}
      {/*  />*/}
      {/*)}*/}
      {/*{checkPerm(permChildren?.[LITIPRSVLEGALDOC]?.perm, 4) && (*/}
      {/*  <DetailCard*/}
      {/*    title="诉保相关法律文书"*/}
      {/*    id="litiPrsvLegalDoc"*/}
      {/*    data={detail?.[`${cardPath}/${LITIPRSVLEGALDOC}`] || []}*/}
      {/*    onSelectChange={onSelectChange}*/}
      {/*    downloadFile={downloadFile}*/}
      {/*    openModal={openModal}*/}
      {/*    deleteFile={deleteFile}*/}
      {/*    printFile={printFile}*/}
      {/*    printSingleFile={printSingleFile}*/}
      {/*    signature={signature}*/}
      {/*    showPdf={showPdf}*/}
      {/*    canDelete={checkPerm(permChildren?.[LITIPRSVLEGALDOC]?.perm, 2)}*/}
      {/*    reviewResult={reviewResult}*/}
      {/*    // cz={path.split("/")[1] === "workbench"}*/}
      {/*  />*/}
      {/*)}*/}
      {/*{checkPerm(permChildren?.[MEDIATIONLEGALDOC]?.perm, 4) && (*/}
      {/*  <DetailCard*/}
      {/*    title="调解相关法律文书"*/}
      {/*    id="mediationLegalDoc"*/}
      {/*    data={detail?.[`${cardPath}/${MEDIATIONLEGALDOC}`] || []}*/}
      {/*    onSelectChange={onSelectChange}*/}
      {/*    downloadFile={downloadFile}*/}
      {/*    openModal={openModal}*/}
      {/*    deleteFile={deleteFile}*/}
      {/*    printFile={printFile}*/}
      {/*    printSingleFile={printSingleFile}*/}
      {/*    signature={signature}*/}
      {/*    showPdf={showPdf}*/}
      {/*    canDelete={checkPerm(permChildren?.[MEDIATIONLEGALDOC]?.perm, 2)}*/}
      {/*    canUpload={!!checkPerm(permChildren?.[MEDIATIONLEGALDOC]?.perm, 1)&&path.indexOf('mediationCommunication') !== -1}*/}
      {/*    reviewResult={reviewResult}*/}
      {/*    sourceTree={sourceTree}*/}
      {/*    getDoc={getDoc}*/}
      {/*  />*/}
      {/*)}*/}



      {(
          <DetailCard
              title="原始证据材料"
              id="originalEvidence"
              data={detail?.[`${cardPath}/${ORIGINALEVIDENCE}`] || []}
              onSelectChange={onSelectChange}
              downloadFile={downloadFile}
              openModal={openModal}
              deleteFile={deleteFile}
              printFile={printFile}
              printSingleFile={printSingleFile}
              signature={signature}
              showPdf={showPdf}
              canDelete={checkPerm(permChildren?.[ORIGINALEVIDENCE]?.perm, 2)}
              reviewResult={reviewResult}
              // cz={path.split("/")[1] === "workbench"}
          />
      )}
      {(
          <DetailCard
              title="诉讼相关法律文书"
              id="litigationLegalDoc"
              data={detail?.[`${cardPath}/${LITIGATIONLEGALDOC}`] || []}
              onSelectChange={onSelectChange}
              downloadFile={downloadFile}
              openModal={openModal}
              deleteFile={deleteFile}
              printFile={printFile}
              printSingleFile={printSingleFile}
              signature={signature}
              showPdf={showPdf}
              canDelete={checkPerm(permChildren?.[LITIGATIONLEGALDOC]?.perm, 2)}
              reviewResult={reviewResult}
              // cz={path.split("/")[1] === "workbench"}
          />
      )}
      { (
          <DetailCard
              title="执行相关法律文书"
              id="executionLegalDoc"
              data={detail?.[`${cardPath}/${EXECUTIONLEGALDOC}`] || []}
              onSelectChange={onSelectChange}
              downloadFile={downloadFile}
              openModal={openModal}
              deleteFile={deleteFile}
              printFile={printFile}
              printSingleFile={printSingleFile}
              signature={signature}
              showPdf={showPdf}
              canDelete={checkPerm(permChildren?.[EXECUTIONLEGALDOC]?.perm, 2)}
              reviewResult={reviewResult}
              // cz={path.split("/")[1] === "workbench"}
          />
      )}
      {(
          <DetailCard
              title="诉保相关法律文书"
              id="litiPrsvLegalDoc"
              data={detail?.[`${cardPath}/${LITIPRSVLEGALDOC}`] || []}
              onSelectChange={onSelectChange}
              downloadFile={downloadFile}
              openModal={openModal}
              deleteFile={deleteFile}
              printFile={printFile}
              printSingleFile={printSingleFile}
              signature={signature}
              showPdf={showPdf}
              canDelete={checkPerm(permChildren?.[LITIPRSVLEGALDOC]?.perm, 2)}
              reviewResult={reviewResult}
              // cz={path.split("/")[1] === "workbench"}
          />
      )}
      {(
          <DetailCard
              title="调解相关法律文书"
              id="mediationLegalDoc"
              data={detail?.[`${cardPath}/${MEDIATIONLEGALDOC}`] || []}
              onSelectChange={onSelectChange}
              downloadFile={downloadFile}
              showSignature={path === '/mediationCenter/mediationOnline/mediationOnline'}
              openModal={openModal}
              cardPath={cardPath}
              systemNum={systemNum}
              deleteFile={deleteFile}
              printFile={printFile}
              printSingleFile={printSingleFile}
              signature={signature}
              showPdf={showPdf}
              canDelete={checkPerm(permChildren?.[MEDIATIONLEGALDOC]?.perm, 2)}
              canUpload={!!checkPerm(permChildren?.[MEDIATIONLEGALDOC]?.perm, 1)&&(path.indexOf('mediationCommunication') !== -1||path.indexOf('preLitimediation') !== -1||path.indexOf('mediationOnline') !== -1)}
              reviewResult={reviewResult}
              sourceTree={sourceTree}
              getDoc={getDoc}
          />
      )}
    </div>
  );
};

export default ElectronicDossierDetail;
